import React from "react";

const ShowMoreShowLessText = ({ text, visibility = 30 }) => {
  const [isshowingMore, setIsShowingMore] = React.useState(false);

  return (
    <>
      {text?.substring(0, isshowingMore ? text.length : visibility)}
      {text?.length > visibility && !isshowingMore && "..."}{" "}
      {text?.length > visibility && (
        <span
          className="c-p"
          onClick={() => setIsShowingMore((p) => !p)}
          style={{
            color: "#1CB735",
            fontWeight: "700",
          }}
        >
          {" "}
          {isshowingMore ? "Show Less" : "Show More"}
        </span>
      )}
    </>
  );
};

export default ShowMoreShowLessText;
